import useDropboxAccount from "@mirage/service-auth/useDropboxAccount";
import { EnvCtx } from "@mirage/service-environment-context/global-env-ctx";
import { useFeatureFlagValue } from "@mirage/service-experimentation/useFeatureFlagValue";
import { convertFeatureValueToBool } from "@mirage/service-experimentation/util";
import { useOnboardingValues } from "@mirage/service-onboarding/hooks";
import { useDashUserAttributes } from "@mirage/shared/eligibility/hooks/useDashUserAttributes";
import i18n from "@mirage/translations";
import { useMemo } from "react";

export function useInitialQuery(
  isStartPage: boolean,
): { query: string; inlineCTAText?: string } | undefined {
  const account = useDropboxAccount();
  const { onboardingValues, hasLoadedOnboardingValues } = useOnboardingValues();
  const { userAttributes } = useDashUserAttributes();

  const featureFlagValue = useFeatureFlagValue(
    "otc_growth_2025_05_13_first_search_query",
  );
  const shouldOverrideFirstTimeViewValue = featureFlagValue === "TEST";
  const initialQueryEnabled = convertFeatureValueToBool(featureFlagValue);

  const isFirstTimeView =
    (hasLoadedOnboardingValues && !onboardingValues?.firstLoginTimeWeb) ||
    shouldOverrideFirstTimeViewValue;

  const isOnWeb = EnvCtx.surface === "web";

  const shouldShowInitialQuery =
    isFirstTimeView &&
    initialQueryEnabled &&
    isOnWeb &&
    isStartPage &&
    userAttributes?.isEligible;

  const initialQuery =
    shouldShowInitialQuery && account ? account.name.display_name : undefined;

  const result = useMemo(() => {
    if (!initialQuery) {
      return undefined;
    }

    return {
      query: initialQuery,
      inlineCTAText: ` — ${i18n.t("first_search_inline_cta")}`,
    };
  }, [initialQuery]);

  return result;
}
